<template>
  <div class="upload-demo" >
  <el-upload v-if="!readOnly" class="upload-btn" action="/callComponent/upload/uploadFile/uploadAllFile" :on-preview="handlePreview"
    :on-remove="handleRemove" :show-file-list="false" :auto-upload="false" :before-upload="beforeUpload" :on-success="handleSuccess" :before-remove="beforeRemove" :on-change="handleFileChange"
    multiple :limit="100" :on-exceed="handleExceed" :file-list="fileList">
    <el-button size="small" type="primary">点击上传</el-button>
    
    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
  </el-upload>
  <div class="fileList">
      <div v-for="(item, index) in uploadList" style="color: #48a2ff;cursor: pointer;" :key="index">
        <span @click="openFile(item.url)">{{ item.name }}</span>
        <el-button size="mini" v-if="!readOnly" type="text" style="color: red;margin-left: 10px;" @click="handleRemove2(index)">删除</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { uploadFile } from '@/api/system/paymentPoolApi'
export default {
  
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 100
    },
    value: [String, Object, Array],
    // fileList: {
    //   type: Array,
    //   default: () => []
    // }
  },
  data() {
    return {
      fileList: [],
      uploadList:[]
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            item = { name: item.name, url: item.url }
            return item;
          });
          this.uploadList = [...this.fileList]
        } else {
          this.fileList = [];
          this.uploadList = []
          return [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    openFile(url) {
      window.open(url)
    },
    beforeUpload(){
      return false
    },
    handleFileChange(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error(this.$t('uploadFile.sizeLimit'))
        return false
      }
      this.fileName = file.name
      if (this.uploadList.length >= this.limit) {
        this.$message.error(`最多上传${this.limit}个文件`)
        return false
      }
      this.doUpload(file.raw)
    },
    async doUpload(file) {
      const formData = new FormData()
      formData.append('uploadFile', file)
      try {
        // const config = {
        //   onUploadProgress: progressEvent => {
        //     const percent = Math.round(
        //       (progressEvent.loaded * 100) / progressEvent.total
        //     )
        //     this.progress = percent < 90 ? percent : 90
        //   }
        // }
        const data = await uploadFile(formData)
        console.log('ssssssssssssssssssss')
        this.uploadList.push({name:data.fileName,url:data.realFileName})
        // this.fileList = this.fileList.concat(this.uploadList);
        // this.$emit('change', this.fileList)
        this.$message.success(this.$t('uploadFile.success'))
      } catch (error) {
        this.$message.error(this.$t('uploadFile.error'))
        console.error('上传文件失败:', error)
      }
    },
    handleRemove(file) {
     const findex = this.uploadList.map(f => f.name).indexOf(file.name);
      if(findex > -1) {
        this.uploadList.splice(findex, 1);
        // this.$emit("change", this.fileList);
      }
    },
    handleRemove2(index) {
     this.uploadList.splice(index, 1);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess(res, file, fileList) {
      console.log(res, file, fileList);
    }
  }
}
</script>
<style>
.upload-demo{
  text-align: left;
}
.upload-btn{
  text-align: left;
}
</style>